import { ACTIONS_FROM_LOCAL_LOGGING } from '../../constants';

export const toggleLocalLogging = enableLocalLog => ({
	type: ACTIONS_FROM_LOCAL_LOGGING.SET_LOCAL_LOGGING,
	enableLocalLog
});



// WEBPACK FOOTER //
// ./src/redux/actions/A_local_logging.js